// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"6b304b08","150":"256bb2fa","407":"40dafe43","453":"f9924df9","475":"cccc6953","494":"ca833076","641":"3b9593ea","797":"847dd6a3","823":"6aa0aca1","935":"502d9979","969":"89dbce60","987":"5b09e649"}[chunkId] + ".chunk.js";
};